// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AssociationRoleManagement, AssociationRoleManagementSchema } from 'api/gen/AssociationRoleManagement';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Username, UsernameSchema } from 'api/gen/Username';

const requiredPart = t.interface({
  isSubjectMember: t.boolean,
  roles: t.array(AssociationRoleManagementSchema),
  userProfileId: t.Integer,
  username: UsernameSchema,
});

export const UserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema = excess(requiredPart);

export interface UserProfileSubjectRoleManagementDtoAssociationRoleManagement extends t.TypeOf<typeof UserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema> {}
